import { ContentItem } from '../types/AppContent';
import { ProductSearchResult } from '@klab-berlin/api-sdk/lib/types/responses/Product';
import { MindItemSearchResult, CourseMindItemSearchResult } from '@klab-berlin/api-sdk/lib/types/responses/MindItem';
import { MuiCardCommonProps } from '../components/cards/MuiCard/MuiCardBase/MuiCardBase';
import { ProductMuiCardProps } from '../components/cards/MuiCard/ProductMuiCard/ProductMuiCard';
import { MindItemMuiCardProps } from '../components/cards/MuiCard/MindItemMuiCard/MindItemMuiCard';
import { VideoMuiCardProps } from '../components/cards/MuiCard/VideoMuiCard/VideoMuiCard';
import { CourseMuiCardProps } from '../components/cards/MuiCard/CourseMuiCard/CourseMuiCard';

export const getCommonCardProps = (item: ContentItem): MuiCardCommonProps => {
  return {
    id: item.id,
    publisher: item.publisher || '',
    description: item.description || '',
    subjects: item.subjects,
    cover: item.thumbnail,
    title: item.title,
    classYears: item.classYears,
    isNew: item.isNew,
    date: item.publisherReleaseDate,
    isReadOnly: item.isReadOnly,
    isPinned: item.isPinned,
    itemData: item,
  };
};

export const getProductMuiCardProps = (item: ContentItem): ProductMuiCardProps => {
  const productItem = item as ProductSearchResult;
  return {
    ...getCommonCardProps(item),
    numberOfAttachments: productItem.attachmentsCount,
    numberOfMindItems: productItem.mindItemsCount,
  };
};

export const getMindItemMuiCardProps = (item: ContentItem): MindItemMuiCardProps => {
  const mindItem = item as MindItemSearchResult;
  return {
    ...getCommonCardProps(item),
    numberOfPages: mindItem.pageCount || undefined,
    product: mindItem.populatedProduct,
  };
};

export const getVideoMuiCardProps = (item: ContentItem): VideoMuiCardProps => {
  const mindItem = item as MindItemSearchResult;
  return {
    ...getCommonCardProps(item),
    product: mindItem.populatedProduct,
  };
};

export const getCourseMuiCardProps = (item: ContentItem): CourseMuiCardProps => {
  const courseItem = item as CourseMindItemSearchResult;
  return {
    ...getCommonCardProps(item),
    contentType: 'course' as const,
    course: courseItem.course,
  };
};
